const baseTheme = {
  breakpoints: ['40em', '52em', '64em'],
  fontSizes: [12, 14, 16, 20, 24, 32, 48, 64],
  sideBarWidth: 65,
  headerHeight: 70,
  minWidgetHeight: 245,
  padding: 20,
  borderRadius: [0, 7, 10, 15, 30],
  background: '#F7F7F7',
  space: [2, 4, 8, 16, 32, 50, 64, 128, 256],
  fontFamily: {
    black: ' RecoletaRegular, sans-serif',
    bold: ' RecoletaBold, sans-serif',
    regular: ' RecoletaRegular, sans-serif',
    mainText: 'RecoletaBold, sans-serif',
    extraBold: 'RecoletaBold, sans-serif',
    extraThin: ' RecoletaRegular, sans-serif',
    light: ' RecoletaRegular, sans-serif',
    semiBold: ' RecoletaRegular, sans-serif',
    thin: 'RecoletaRegular, sans-serif',
    body: 'system-ui, sans-serif',
    heading: 'inherit',
    monospace: 'RecoletaRegular, monospace',
  },

  fontFamilyArabic: {
    black: ' KalligArbRegular, sans-serif',
    bold: ' NaveidBold, sans-serif',
    regular: ' KalligArbRegular, sans-serif',
    mainText: 'NaveidBold, sans-serif',
    extraBold: 'NaveidBold, sans-serif',
    extraThin: ' KalligArbRegular, sans-serif',
    light: ' KalligArbRegular, sans-serif',
    semiBold: ' NaveidBold, sans-serif',
    thin: 'KalligArbRegular, sans-serif',
    body: 'system-ui, sans-serif',
    heading: 'inherit',
    monospace: 'KalligArbRegular, monospace',
  },
  fontWeights: {
    light: 300,
    body: 400,
    heading: 700,
    semiBold: 600,
    bold: 700,
  },
  lineHeights: {
    body: 1.5,
    heading: 1.25,
  },
  shadows: {
    small: '0 0 4px rgba(0, 0, 0, .125)',
    large: '0 0 24px rgba(0, 0, 0, .125)',
  },
  variants: {},
  text: {},
};

export const fontsArabic = {
  smallRegular: {
    fontSize: baseTheme.fontSizes[0],
    fontFamily: baseTheme.fontFamilyArabic.regular,
  },

  smallBold: {
    fontSize: baseTheme.fontSizes[0],
    fontFamily: baseTheme.fontFamilyArabic.bold,
  },

  mediumRegular: {
    fontSize: baseTheme.fontSizes[1],
    fontFamily: baseTheme.fontFamilyArabic.regular,
  },

  mediumBold: {
    fontSize: baseTheme.fontSizes[1],
    fontFamily: baseTheme.fontFamilyArabic.semiBold,
  },

  largeRegular: {
    fontSize: baseTheme.fontSizes[2],
    fontFamily: baseTheme.fontFamilyArabic.regular,
  },

  largeBold: {
    fontSize: baseTheme.fontSizes[2],
    fontFamily: baseTheme.fontFamilyArabic.bold,
  },

  xlargeRegular: {
    fontSize: baseTheme.fontSizes[3],
    fontFamily: baseTheme.fontFamilyArabic.regular,
    marginBottom: 5,
  },

  xlargeBold: {
    fontSize: baseTheme.fontSizes[4],
    fontFamily: baseTheme.fontFamilyArabic.bold,
    marginBottom: 5,
  },
};
export const fonts = {
  smallRegular: {
    fontSize: baseTheme.fontSizes[0],
    fontFamily: baseTheme.fontFamily.semiBold,
  },

  smallBold: {
    fontSize: baseTheme.fontSizes[0],
    fontFamily: baseTheme.fontFamily.semiBold,
  },

  mediumRegular: {
    fontSize: baseTheme.fontSizes[1],
    fontFamily: baseTheme.fontFamily.regular,
  },

  mediumBold: {
    fontSize: baseTheme.fontSizes[1],
    fontFamily: baseTheme.fontFamily.semiBold,
  },

  largeRegular: {
    fontSize: baseTheme.fontSizes[2],
    fontFamily: baseTheme.fontFamily.regular,
  },

  largeBold: {
    fontSize: baseTheme.fontSizes[2],
    fontFamily: baseTheme.fontFamily.bold,
  },

  xlargeRegular: {
    fontSize: baseTheme.fontSizes[3],
    fontFamily: baseTheme.fontFamily.regular,
    marginBottom: 5,
  },

  xlargeBold: {
    fontSize: baseTheme.fontSizes[4],
    fontFamily: baseTheme.fontFamily.bold,
    marginBottom: 5,
  },
};
